// Espécies de atividade. Espelha Crm::DealTask::ACTIVITY_TYPES no servidor:
// mexeu aqui, mexe lá, senão a validação do modelo rejeita o que a tela
// oferece.
//
// `note` (anotação) é o caso à parte: é registro do que aconteceu, não
// compromisso. Nasce realizada, não tem data marcada, e o servidor a mantém
// fora da agenda e do calendário.
export const ACTIVITY_TYPES = [
  { value: 'call', label: 'Ligação', emoji: '📱' },
  { value: 'whatsapp', label: 'WhatsApp', emoji: '💬' },
  { value: 'email', label: 'E-mail', emoji: '✉️' },
  { value: 'meeting', label: 'Reunião', emoji: '🤝' },
  { value: 'visit', label: 'Visita', emoji: '📍' },
  { value: 'follow_up', label: 'Follow-up', emoji: '📞' },
  { value: 'reminder', label: 'Lembrete', emoji: '🔔' },
  { value: 'note', label: 'Anotação', emoji: '📝' },
  { value: 'other', label: 'Outro', emoji: '📋' },
];

export const NOTE_TYPE = 'note';

export const ACTIVITY_EMOJI = ACTIVITY_TYPES.reduce((acc, type) => {
  acc[type.value] = type.emoji;
  return acc;
}, {});

export const ACTIVITY_LABEL = ACTIVITY_TYPES.reduce((acc, type) => {
  acc[type.value] = type.label;
  return acc;
}, {});

// O que pode ser agendado. Anotação some do seletor quando a tela está
// marcando compromisso.
export const SCHEDULABLE_TYPES = ACTIVITY_TYPES.filter(
  type => type.value !== NOTE_TYPE
);
